import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
import theme from './config/theme';
import Topic from './pages/Topic';
import Startpage from './pages/Startpage';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Hotspots from './pages/Hotspots';
import Home from './pages/Home';
import Browse from './pages/Browse';
import Search from './pages/Search';
import Wizard from './pages/Wizard';
import NotFound from './pages/NotFound';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { useHtmlLang } from './hooks/useHtmlLang';

const SkipLink = styled.a`
  position: absolute;
  left: -9999px;
  z-index: 9999;
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.elvitaWebPurple};
  color: #fff;
  font-size: ${({ theme }) => theme.fontSizes.m};
  font-family: ${({ theme }) => theme.fonts.light};
  text-decoration: none;

  &:focus {
    left: 8px;
    top: 8px;
  }
`;

function App() {
  const { enableLinkTracking } = useMatomo();

  // Update HTML lang attribute dynamically for WCAG compliance
  useHtmlLang();

  // enableLinkTracking internally calls hooks (useOutboundClickListener),
  // so it must be called at the top level — not inside useEffect.
  enableLinkTracking();

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <SkipLink href="#main-content">Skip to main content</SkipLink>
        <Routes>
          <Route path="/" element={<Startpage />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="/wizard/:path" element={<Wizard />} />
          <Route path="/wizard/:path/:childId" element={<Wizard />} />
          <Route
            path="/:productId/hotspots/:hotspotId"
            element={<Hotspots />}
          />
          <Route path="/:productId/topics/:topicId" element={<Topic />} />
          <Route path="/:productId/:path/topics/:topicId" element={<Topic />} />
          <Route path="/:productId/browse" element={<Browse />} />
          <Route path="/:productId/browse/:path" element={<Browse />} />
          <Route
            path="/:productId/browse/:path/:childId"
            element={<Browse />}
          />
          <Route path="/search/:searchType" element={<Search />} />
          <Route path="/search/:searchType/:searchTerm" element={<Search />} />
          <Route path="/:productId/search/:searchType" element={<Search />} />
          <Route
            path="/:productId/search/:searchType/:searchTerm"
            element={<Search />}
          />
          <Route path="/:productId" element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
      <div id="modal"></div>
    </ThemeProvider>
  );
}

export default App;
